module.exports = __webpack_public_path__ + "static/business-a8bc7464557efb22ff94e259e49d60a9.jpg";